// src/pages/AdminDashboard.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import Sidebar from '../components/sidebar';
import Notification from '../components/Notification';
import ProfileDropdown from '../components/ProfileDropdown';
import '../styles/Dashboard.css';
// ✅ IMPORT KOMPONEN BARU

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState(null);
    const [loading, setLoading] = useState(true);
    
    // 1. ✅ TAMBAHKAN STATE INI UNTUK SIDEBAR
    // Menggunakan window.innerWidth agar default-nya terbuka di PC, dan tertutup di HP
    const [isOpen, setIsOpen] = useState(window.innerWidth >= 992);

    useEffect(() => {
        const storedUsername = localStorage.getItem('username');
        const isSuperAdmin = localStorage.getItem('is_super_admin') === 'true';

        if (!storedUsername || !isSuperAdmin) {
            alert('Akses ditolak. Anda bukan Super Admin atau belum login.');
            navigate('/login', { replace: true });
        } else {
            setUsername(storedUsername);
            setLoading(false);
        }
    }, [navigate]);

    if (loading || !username) {
        return <div>Memuat Panel Admin...</div>;
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">
                <div className="header-title">
                    <h2>Panel Admin - {username}</h2>
                </div>
                <div className="header-right">
                    <Notification username={username} />
                    <ProfileDropdown username={username} />
                </div>
            </div>

            {/* 2. ✅ KIRIM PROPS KE SIDEBAR */}
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            {/* Catatan: Karena sidebar sekarang bisa buka-tutup, pastikan margin-left responsif. 
                Jika hardcode 250px, konten tidak akan bergeser saat sidebar ditutup. 
                Saran: Gunakan class CSS alih-alih inline style */}
            <div 
                className={`dashboard-content ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`} 
                style={{ marginLeft: isOpen && window.innerWidth >= 992 ? '250px' : '0px' }}
            >
                <Outlet />
            </div>
        </div>
    );
};

export default AdminDashboard;